import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Kuala_Lumpur');

export default moment;
